import { defineMessages } from 'react-intl';

import globalMessages from '../../utils/globalMessages';

const messages = defineMessages({
    ...globalMessages,

    title: {
        id: 'feeMessages.title',
        defaultMessage: 'Tarifações',
    },

    titleFeeMessage: {
        id: 'feeMessages.titleFeeMessage',
        defaultMessage: 'Eventos {entity}',
    },

    home: {
        id: 'home.title',
        defaultMessage: 'Início',
    },

    deleteFeeMessage: {
        id: 'feeMessages.deleteFeeMessage',
        defaultMessage: 'Excluir eventos',
    },
});

export default messages;
